// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Gallery_gallery__UDzrW","single":"Gallery_single__4Ta6y","double":"Gallery_double__msKal","triple":"Gallery_triple__CRAd2","quadruple":"Gallery_quadruple__Zp8It"};